'use strict';

const NOTIFICATION = require('./notification.constant');

const STATUS =
  {
    DRAFT: {
      name: 'DRAFT',
      notifications: [],
      text: 'Draft'
    },
    SUBMITTED: {
      name: 'SUBMITTED',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_SUBMIT, NOTIFICATION.EMAIL_TO_CAMPUS_ADMIN_ON_FORM_SUBMIT],
      text: 'Submitted'
    },
    APPROVED_BY_CAMPUS_ADMIN: {
      name: 'APPROVED_BY_CAMPUS_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_APPROVE_BY_CAMPUS_ADMIN, NOTIFICATION.EMAIL_TO_UCOP_ADMIN_ON_FORM_APPROVE_BY_CAMPUS_ADMIN],
      text: 'Approved by EHS Liaison'
    },
    DECLINED_BY_CAMPUS_ADMIN: {
      name: 'DECLINED_BY_CAMPUS_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_DECLINE_BY_CAMPUS_ADMIN],
      text: 'Denied by EHS Liaison'
    },
    APPROVED_BY_UCOP_ADMIN: {
      name: 'APPROVED_BY_UCOP_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_APPROVE_BY_UCOP_ADMIN, NOTIFICATION.EMAIL_TO_UCOP_ADMIN_ON_FORM_APPROVE_BY_UCOP_ADMIN_TO_SETUP_ACCOUNT],
      text: 'Approved by UCOP EHS'
    },
    DECLINED_BY_UCOP_ADMIN: {
      name: 'DECLINED_BY_UCOP_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_DECLINE_BY_UCOP_ADMIN],
      text: 'Denied by UCOP EHS'
    },
    PROGRAM_NAME_GENERATED: {
      name: 'PROGRAM_NAME_GENERATED',
      notifications: [],
      text: 'Program Name Generated'
    },
    PENDING_VENDOR_ACCOUNT_CREATION: {
      name: 'PENDING_VENDOR_ACCOUNT_CREATION',
      notifications: [NOTIFICATION.EMAIL_TO_VENDOR_FOR_ACCOUNT_CREATION],
      text: 'Pending Supplier Account Creation'
    },
    VENDOR_ACCOUNT_CREATED: {
      name: 'VENDOR_ACCOUNT_CREATED',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_ENABLE_ORDERING],
      text: 'Ready to Order'
    },
    INACTIVATED: {
      name: 'INACTIVATED',
      notifications: [],
      text: 'Deleted'
    },
    CORRECTION_REQ_BY_CAMPUS_ADMIN: {
      name: 'CORRECTION_REQ_BY_CAMPUS_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_CORRECTION_REQ_BY_CAMPUS_ADMIN],
      text: 'Correction(s) Required'
    },
    CORRECTION_REQ_BY_UCOP_ADMIN: {
      name: 'CORRECTION_REQ_BY_UCOP_ADMIN',
      notifications: [NOTIFICATION.EMAIL_TO_UNIT_REP_ON_FORM_CORRECTION_REQ_BY_UCOP_ADMIN],
      text: 'Correction(s) Required'
    },
    CLEANUP: {
      name: 'CLEANUP',
      notifications: [],
      text: 'Cleanup'
    },
    AMEND_WITH_WORKFLOW: {
      name: 'AMEND_WITH_WORKFLOW',
      notifications: [NOTIFICATION.EMAIL_TO_PEOPLE_FOR_FORM_CHANGES_ON_AMENDMENT, NOTIFICATION.EMAIL_TO_PEOPLE_FOR_EMPLOYEE_ROSTER_CHANGES_ON_AMENDMENT],
      text: 'Form question(s) responses changed'
    },
    GRANTED_ACCESS_TO_RESTRICTED_SITE: {
      name: 'GRANTED_ACCESS_TO_RESTRICTED_SITE',
      notifications: [],
      text: 'Granted restricted site access changed'
    },
    GRANTED_ACCESS_TO_INDIVIDUAL_RESTRICTED_SITE: {
      name: 'GRANTED_ACCESS_TO_INDIVIDUAL_RESTRICTED_SITE',
      notifications: [],
      text: 'Granted individual restricted site access changed'
    }
  };

module.exports = STATUS;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/status.constant.js
// module id = ObzP
// module chunks = 1